import { render, staticRenderFns } from "./SavedCourses.vue?vue&type=template&id=4cb4f8ea&scoped=true&lang=pug&"
import script from "./SavedCourses.vue?vue&type=script&lang=js&"
export * from "./SavedCourses.vue?vue&type=script&lang=js&"
import style0 from "./SavedCourses.vue?vue&type=style&index=0&id=4cb4f8ea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb4f8ea",
  null
  
)

export default component.exports